import BayStatus from "@/common/models/BayStatus";
import InrangePricing from "@/common/models/InrangePricing";
import PincodeModel from "@/common/models/PincodeModel";
import axios from "axios";

export default class apiBay {


    static async getPricing(sitename: string): Promise<Array<InrangePricing>> {
        let models = new Array<InrangePricing>();

        let response = await axios.post("api/Bay/GetPricing", {
            siteSettingName: sitename
        });

        response.data.models.forEach((item : any) => models.push(InrangePricing.from(item)))

        return models;
    }

    // Pricing with the location's category discount applied, plus the effective tax rate
    // (caller computes the tax amount from it).
    static async getDisplayPricing(sitename: string): Promise<{ models: Array<InrangePricing>, taxRate: number, taxInclusive: boolean, bayModifiers: Array<any> }> {
        let response = await axios.post("api/Bay/GetDisplayPricing", {
            siteSettingName: sitename
        });

        let models = new Array<InrangePricing>();
        response.data.models.forEach((item : any) => models.push(InrangePricing.from(item)))

        return { models: models, taxRate: response.data.taxRate ?? 0, taxInclusive: response.data.taxInclusive ?? false, bayModifiers: response.data.bayModifiers ?? [] };
    }

    // Pricing plus the location's associated category, tax rates and per-bay modifiers (Bay Pricing screen).
    static async getPricingSettings(sitename: string): Promise<{ models: Array<InrangePricing>, categoryId: string, taxRates: Array<string>, taxInclusive: boolean, bayModifiers: Array<any> }> {
        let response = await axios.post("api/Bay/GetPricing", {
            siteSettingName: sitename
        });

        let models = new Array<InrangePricing>();
        response.data.models.forEach((item : any) => models.push(InrangePricing.from(item)))

        return {
            models: models,
            categoryId: response.data.categoryId ?? "",
            taxRates: response.data.taxRates ?? [],
            taxInclusive: response.data.taxInclusive ?? false,
            bayModifiers: response.data.bayModifiers ?? []
        };
    }

    static async savePricing(sitename: string, models: Array<InrangePricing>, categoryId: string = "", taxRates: Array<string> = [], bayModifiers: Array<any> = [], taxInclusive: boolean = false): Promise<void> {
        let response = await axios.post("api/Bay/SavePricing", {
            siteSettingName: sitename,
            categoryId: categoryId,
            taxRates: taxRates,
            taxInclusive: taxInclusive,
            bayModifiers: bayModifiers,
            models: models,
        });
    }


    // The location's configured bays (identity, number, and the devices fitted in them). Use this
    // where bays are being edited - the globalId identifies a bay across a change to its number.
    // canSetBayStatus gates whether the manual "set bay status" control should be shown at all.
    static async getBays(sitename: string): Promise<{ models: Array<any>, canSetBayStatus: boolean }> {
        let response = await axios.post("api/Bay/GetBays", {
            siteSettingName: sitename
        });

        return { models: response.data.models ?? [], canSetBayStatus: response.data.canSetBayStatus ?? false };
    }

    // Manually assert a bay's status - for when a device's webhook report doesn't arrive when
    // expected. Only meaningful (and only enforced server-side) when a device handler is enabled
    // for the site.
    static async setBayStatus(sitename: string, bayId: number, status: number): Promise<void> {
        await axios.post("api/Bay/SetBayStatus", {
            siteSettingName: sitename,
            bayId: bayId,
            status: status
        });
    }


    static async getBayStatus(sitename: string): Promise<Array<BayStatus>> {
        let models = new Array<BayStatus>();

        let response = await axios.post("api/Bay/GetBayStatus", {
            siteSettingName: sitename
        });

        response.data.models.forEach((item: any) =>
            models.push(BayStatus.from(item))
        );

        return models;
    }


    static async startBay(sitename: string, playerId: number, duration: number, bayId: number, message: string, unlimited: boolean = false): Promise<PincodeModel> {
        let response = await axios.post("api/Bay/StartBay", {
            siteSettingName: sitename,
            playerId: playerId,
            duration: duration,
            bayId: bayId,
            message: message,
            unlimited: unlimited
        });

        let model = PincodeModel.from(response.data.model)
        return model;
    }
}
